import { render } from "./DashboardThree.vue?vue&type=template&id=2b4f9439"
import script from "./DashboardThree.vue?vue&type=script&lang=js"
export * from "./DashboardThree.vue?vue&type=script&lang=js"

import "./DashboardThree.vue?vue&type=style&index=0&id=2b4f9439&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__